// src/components/FooterComponents.jsx
import React from 'react';
import '../styles/footer.css';

const Footer = ({ data }) => {
  const biz = data?.footer?.business;
  const footerContact = data?.footer?.contact || data?.contact;
  const footerBg = data?.footer?.bg;

  // 라벨에서 키워드 추출 → socialIcons와 자동 매칭
  const getSocialMatchKey = (label = "") => {
    const t = label.toLowerCase();
    if (t.includes('kakao') || t.includes('카카오')) return 'kakao';
    if (t.includes('insta') || t.includes('인스타')) return 'instagram';
    if (t.includes('naver') || t.includes('네이버')) return 'naver';
    return null;
  };

  // 버튼 아이콘 선택 로직: 버튼 자체 icon/logo → socialIcons 매칭 → 없음
  const resolveButtonIcon = (btn) => {
    if (btn.icon) return btn.icon;
    if (btn.logo) return btn.logo;

    const key = getSocialMatchKey(btn.label || btn.text);
    if (!key) return null;

    const found = (data?.socialIcons || []).find(s =>
      s.label?.toLowerCase() === key || s.className?.toLowerCase() === key
    );
    return found?.icon || null;
  };

  return (
    <>
     {/* Contact Section - Footer 위에 추가 */}
      <section className="footer-contact" id="center">
        <div className="container">
          <div className="contact-content">
            <div className="contact-header">
              <div className="contact-header-text">
                <h2>{footerContact?.title}</h2>
                <p>{footerContact?.desc}</p>
              </div>

              {/* ▼ 두 개 고정: 1번=로고, 2번=화살표 */}
              <div className="contact-buttons">
                {(footerContact?.buttons || []).slice(0, 2).map((b, i) => {
                  const label = b.text || b.label;

                  // 왼쪽(첫 번째) 버튼: content.json 로고 사용
                  if (i === 0) {
                    // 기존에 구현했던 아이콘 해석 함수가 있다면 그대로 사용
                    // 없으면 b.icon 또는 b.logo를 우선 사용
                    const icon =
                      b.icon || b.logo ||
                      (data?.socialIcons || []).find(s => {
                        const key = (label || '').toLowerCase();
                        return key.includes(s.label?.toLowerCase()) || key.includes(s.className?.toLowerCase());
                      })?.icon;

                    return (
                      <a key={i} href={b.href} className="contact-btn" target={b.target || '_self'} rel="noreferrer">
                        <span className="contact-btn-label">{label}</span>
                        {icon && <img className="contact-btn-icon" src={icon} alt="" aria-hidden="true" />}
                      </a>
                    );
                  }

                  // 오른쪽(두 번째) 버튼: 로고 대신 오른쪽 화살표
                  return (
                    <a key={i} href={b.href} className="contact-btn contact-btn--ghost" target={b.target || '_self'} rel="noreferrer">
                      <span className="contact-btn-label">{label}</span>
                      <span className="contact-btn-arrow" aria-hidden="true">→</span>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Footer */}
      <footer
        className="footer"
        id="footer"
        style={footerBg ? { '--footer-bg': `url(${footerBg})` } : undefined}
      >
        {/* Middle Info */}
        <div className="footer-mid container">
          <div className="footer-menu">
            <h4>Menu</h4>
            <ul>
              {(data?.menu || []).map((m) => {
                const href = m.label === '다이빙이지' ? '/about' : (m.href || '#');
                return (
                  <li key={href}>
                    <a href={href}>{m.label}</a>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="footer-center">
            <h4>Customer Center</h4>
            <p>
              <strong>{data?.contact?.info?.telTitle || "문의"}</strong>
              <span>{data?.contact?.info?.tel}</span>
            </p>
            <p>
              <strong>{data?.contact?.info?.hoursTitle || "상담시간"}</strong>
              <span>{data?.contact?.info?.hours}</span>
            </p>
          </div>

          <div className="footer-sns">
            <h4>Social Media</h4>
            {(data?.contact?.info?.sns || []).map((s, i) => (
              <p key={i}>
                <strong>{s.label}</strong>
                <span>{s.value || ""}</span>
              </p>
            ))}
          </div>
        </div>

        {/* Bottom Business & Legal */}
        <div className="footer-bottom container">
          {biz ? (
            <div className="footer-business">
              <p><strong>상호명</strong><span>{biz.name}</span></p>
              <p><strong>대표자명</strong><span>{biz.ceo}</span></p>
              <p><strong>사업자등록번호</strong><span>{biz.regno}</span></p>
              <p><strong>사업장주소</strong><span>{biz.address}</span></p>
              <p className="footer-business-phone">
                <strong>연락처</strong><span>{biz.phone}</span>
              </p>
            </div>
          ) : (
            <div
              className="footer-info"
              dangerouslySetInnerHTML={{ __html: (data?.footer?.legal || "").replaceAll("\n","<br/>") }}
            />
          )}

          <div className="footer-legal">
            <p className="footer-privacy">
              <a href={(biz && biz.privacyLink) || "#!"}>개인정보처리방침</a>
            </p>
            <p className="footer-copy">{data?.footer?.copyright}</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
